import React, {Component} from 'react';
import {Row, Col} from "reactstrap";
import './VideoPlayerView.scss'
import ReactPlayer from "react-player";
import webConfig from "../../config/WebConfig";
import {Carousel} from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader

class VideoPlayerView extends Component {

    render() {
        let {youtubeLikes, version,landing} = this.props;
        return (
            <div id='yourtube' className="container videoPlayer-view pt-3 pb-6">
                <Row>
                    <Col xs={12} sm={12} md={12} lg={12}>
                        <div className='text-center'>
                            <h1 className='main-topic'>
                                Explore our Youtube
                            </h1>
                            <p className='video-para mb-0'>{landing ? webConfig.youtubePara : webConfig.teacherYoutubePara} </p>
                            {/*<p className='video-para'>{webConfig.youtubeSinPara} </p>*/}

                                <div className={'videoPlayer-view my-4'}>
                                    <Col sm={12} md={12} lg={10} xl={10}>
                                        <Carousel showStatus={false} showArrows={true} showThumbs={false}>
                                            {youtubeLikes.map((link, index) => <div>
                                                    <ReactPlayer key={index} controls={true} width='100%' height={'600px'}
                                                                 url={link}/>
                                                </div>
                                            )

                                            }
                                        </Carousel>


                                    </Col>

                                </div>

                        </div>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default VideoPlayerView;
